(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const unsupportedExactClaims = new Set([
    'free worldwide shipping',
    'always free shipping',
    'free size exchange',
    'free size exchanges',
    'fast production',
    'arrives in 8–12 business days',
    'ships in 3–5 business days',
    'no import duties',
    'no surprise duties at delivery',
    'duties included',
    'duties and taxes prepaid',
    'prepaid rates',
    'bestseller',
    'best seller',
    'most popular'
  ]);

  const urgencyPattern = /\b(?:only\s+\d+\s+left|low\s+stock|people\s+(?:are\s+)?viewing|sold\s+in\s+the\s+last\s+24|selling\s+fast|hurry|ends?\s+soon)\b/i;
  const promotionalPattern = /^(?:sale|on sale|\d{1,3}\s*%\s*off)$/i;
  const reviewPattern = /\b(?:\d[\d,.]*\s+reviews?|verified\s+buyers?|customer\s+rating)\b/i;

  const removeIfUnsupported = (element) => {
    if (!(element instanceof Element)) return;
    const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
    const normalized = normalize(text);

    const isSaleBadge =
      element.matches('.price__badge-sale, .card__badge .badge') &&
      promotionalPattern.test(text);

    const isUnsupported =
      unsupportedExactClaims.has(normalized) ||
      urgencyPattern.test(text) ||
      reviewPattern.test(text) ||
      isSaleBadge;

    if (isUnsupported) element.remove();
  };

  const cleanRoot = (root = document) => {
    const candidates = root.querySelectorAll(
      '.badge, .price__badge-sale, .card__badge .badge, [class*="urgency"], [class*="stock"], [class*="viewer"], [class*="review-count"], [class*="testimonial"], [data-urgency], [data-viewers]'
    );

    candidates.forEach(removeIfUnsupported);

    root.querySelectorAll(
      '.card-wrapper s.price-item, .product__info-container s.price-item, .predictive-search s.price-item'
    ).forEach((element) => element.remove());

    root.querySelectorAll(
      '.card-wrapper .price__sale, .product__info-container .price__sale, .predictive-search .price__sale'
    ).forEach((saleContainer) => {
      const currentPrice = saleContainer.querySelector('.price-item--sale');
      const regularContainer = saleContainer.parentElement?.querySelector('.price__regular');
      if (currentPrice && regularContainer) {
        regularContainer.innerHTML = '';
        regularContainer.appendChild(currentPrice);
      }
      saleContainer.remove();
    });
  };

  const run = () => {
    document.body.classList.add('bpc-integrity-cleanup-active');
    cleanRoot(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) {
          removeIfUnsupported(node);
          cleanRoot(node);
        }
      });
    });
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
